import React, { useState } from "react";
import AuthLayout from "../../layouts/AuthLayout";
import { Box, Stack, Typography, useMediaQuery } from "@mui/material";
import { CustomInput } from "../../Components/Common/CustomInput";
import { EmailOutlined, LoginRounded } from "@mui/icons-material";
import { CustomBtn } from "../../Components/Common/CustomBtn";
import { useNavigate } from "react-router-dom";
import axiosInstance, { BASE_URL } from "../../utils/config/config";
import axios from "axios";
import { ErrorSnackbar } from "../../Components/Common/CustomSnackbar";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [emailSent, setEmailSent] = useState(false);
  const [errorState, setErrorState] = useState({
    error: false,
    message: "",
  });

  const handleForgetPasswordEmail = async () => {
    try {
      if (!email) {
        setErrorState({ error: true, message: "Email is required" });
        return;
      }
      const response = await axios.post(`${BASE_URL}/user/forgetPassword`, {
        email,
      });

      if (response) {
        setEmailSent(true);
      }
    } catch (err) {
      console.log("ifif", err.status);
      if (err.status == 404) {
        setErrorState({ error: true, message: "Invalid Email." });
      } else {
        setErrorState({
          error: true,
          message: "Failed to send reset password.",
        });
      }
    }
  };
  const smallScreen = useMediaQuery("(max-width:800px)");

  return (
    <AuthLayout forgotPass>
      {emailSent ? (
        <Box>
          <Typography
            sx={{
              fontSize: "22px",
              fontFamily: "Inter-SemiBold",
              color: "#000",
              mb: 4,
            }}
          >
            Reset Password email has been sent to {email}
          </Typography>
          <Stack
            direction={"row"}
            sx={{
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <CustomBtn
              text="Go to Login"
              Icon={LoginRounded}
              width={smallScreen ? "75%" : "50%"}
              onClick={() => navigate("/login")}
            />
          </Stack>
        </Box>
      ) : (
        <Box>
          <Typography
            sx={{
              fontSize: "22px",
              fontFamily: "Inter-SemiBold",
              color: "#000",
              mb: 4,
            }}
          >
            Enter your account’s email address and we’ll send you a link to
            reset your password.
          </Typography>

          <CustomInput
            placeholder="Email"
            Icon={EmailOutlined}
            value={email}
            setValue={setEmail}
          />

          <Stack
            direction={"row"}
            sx={{
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <CustomBtn
              text="Send Reset Link"
              Icon={LoginRounded}
              width={smallScreen ? "75%" : "50%"}
              onClick={handleForgetPasswordEmail}
            />
          </Stack>
        </Box>
      )}

      <ErrorSnackbar
        error={errorState.error}
        handleCloseError={() => setErrorState({ error: false, message: "" })}
        errorMsg={errorState.message}
      />
    </AuthLayout>
  );
};

export default ForgotPassword;
